import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Button, Overlay } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import QueryPopover, { QueryMode } from './QueryPopover';
import { loadSavedQueries, createSavedQuery, updateSavedQuery, deleteSavedQuery } from './actions';

class QuerySelector extends Component {
	constructor(props) {
		super(props);
		this.handleToggle = this.handleToggle.bind(this);
		this.handleSelectQuery = this.handleSelectQuery.bind(this);
		this.handleSaveQuery = this.handleSaveQuery.bind(this);
		this.handleDeleteQuery = this.handleDeleteQuery.bind(this);
		this.handleModeChange = this.handleModeChange.bind(this);

		this.state = {
			showOverlay: false,
			mode: QueryMode.DEFAULT
		};
	}

	componentDidMount() {
		const { queryType, loadSavedQueries } = this.props;
		loadSavedQueries({ queryType });
	}

	handleToggle() {
		this.setState({ showOverlay: !this.state.showOverlay });
	}

	handleSelectQuery(query) {
		this.props.onSelectQuery(query);
		this.setState({
			showOverlay: false,
			mode: QueryMode.DEFAULT
		});
	}

	handleSaveQuery(values) {
		const queryFilters = this.props.filters || {};

		const savedQuery = {
			name: values.name,
			type: this.props.queryType,
			query: {}
		};

		Object.keys(queryFilters).forEach(filter => {
			if (values[filter]) {	// include filter = true
				const fields = queryFilters[filter].fields || {};
				Object.assign(savedQuery.query, fields);
			}
		})

		const onSaveSuccess = (response) => {
			this.props.loadSavedQueries({ queryType: this.props.queryType });
			this.handleSelectQuery(response.entities.savedQueries[response.result]);
		};

		if (values.id && values.id > 0) {
			this.props.updateSavedQuery(values.id, savedQuery, onSaveSuccess);
		} else {
			this.props.createSavedQuery(savedQuery, onSaveSuccess);
		}
	}

	handleDeleteQuery(query) {
		this.props.deleteSavedQuery(query.id, () => {
			this.props.loadSavedQueries({ queryType: this.props.queryType });
			if (this.props.selectedQuery && this.props.selectedQuery.id === query.id) {
				this.handleSelectQuery(null);
			}
		});
	}

	handleModeChange(mode) {
		this.setState({ mode });
	}

	render() {
		const { buttonClassName, queries, selectedQuery, filters, t } = this.props;

		return <div className='btn-group' style={{ position: 'relative' }}>
			<Button
				ref={button => {
					this.target = button;
				}}
				onClick={this.handleToggle}
				className={buttonClassName}
			>
				<FontAwesomeIcon icon={faFilter} />
			</Button>

			<Overlay
				show={this.state.showOverlay}
				onHide={() => this.setState({ showOverlay: false })}
				placement='bottom'
				rootClose
				target={() => ReactDOM.findDOMNode(this.target)}
			>
				<QueryPopover
					buttonClassName={buttonClassName}
					onModeChange={this.handleModeChange} mode={this.state.mode}
					queries={queries} selectedQuery={selectedQuery}
					filters={filters}
					onSelectQuery={this.handleSelectQuery} onSaveQuery={this.handleSaveQuery} onDeleteQuery={this.handleDeleteQuery}
					onCancel={this.handleToggle}
				/>
			</Overlay>

		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		filters,
		entities: { savedQueries } } = state;

	const savedQueriesFilter = filters.savedQueriesByType[ownProps.queryType] || { ids: [] };

	return {
		queries: savedQueriesFilter.ids.map(id => savedQueries[id])
	};
};

export default connect(mapStateToProps, {
	loadSavedQueries,
	createSavedQuery,
	updateSavedQuery,
	deleteSavedQuery
})(withTranslation()(QuerySelector));